/**
 * Türkçe para ve sayı formatlama utility'leri.
 * Tüm projede para gösterimlerinde kullanılır.
 *
 * Örnek: formatPara(1500.5)       → "1.500,50"
 *        formatPara(1500.5, 'TL') → "1.500,50 TL"
 *        formatSayi(1500)         → "1.500"
 */

/**
 * Sayıyı Türkçe para formatına çevirir: 1.500,00
 * @param {number} tutar - Formatlanacak tutar
 * @param {string} [birim] - Para birimi (opsiyonel, ör: 'TL', 'USD')
 * @param {number} [ondalik=2] - Ondalık basamak sayısı
 * @returns {string} Formatlanmış para string'i
 */
export function formatPara(tutar, birim, ondalik = 2) {
  if (tutar == null || isNaN(tutar)) tutar = 0;
  const formatted = Number(tutar).toLocaleString('tr-TR', {
    minimumFractionDigits: ondalik,
    maximumFractionDigits: ondalik,
  });
  if (birim) return formatted + ' ' + birim;
  return formatted;
}

/**
 * Sayıyı Türkçe formata çevirir (ondalıksız): 1.500
 * @param {number} sayi - Formatlanacak sayı
 * @returns {string} Formatlanmış sayı string'i
 */
export function formatSayi(sayi) {
  if (sayi == null || isNaN(sayi)) return '0';
  return Number(sayi).toLocaleString('tr-TR');
}
